import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DatePicker } from "../../../share/Elements";
import { setDateFilter } from "../../../storeManager/Reducers/datesFilterSlice";
import { ReducerType } from "../../../storeManager/ReducerType";
import React from "react";

const DateFilter = () => {
  const [fromDate, setFromDate] = useState<Date>(new Date());
  const [toDate, setToDate] = useState<Date>(new Date());
  const dispatch = useDispatch();
  const dateFilter = useSelector<ReducerType, DateFilterViewModel>(
    (state) => state.reducerDateFilter
  );
  // Add the following code to update date values
  useEffect(() => {
    setFromDate(dateFilter.from ? new Date(dateFilter.from!) : new Date()); // Set the initial values
    setToDate(dateFilter.to ? new Date(dateFilter.to!) : new Date());
  }, [dateFilter]);

  const handleFromDateChange = (e) => {
    // Assuming you have a way to get the raytebValue
    const fromDateInput = document.getElementById("fromDate"); // Assuming you have an element with id "toDate"
    const raytebValue = fromDateInput?.getAttribute("rayteb-value");
    const newFromDate = new Date(raytebValue!);
    setFromDate(newFromDate);
    dispatch(setDateFilter({ from: newFromDate, to: dateFilter.to }));
  };

  const handleToDateChange = (e) => {
    // Assuming you have a way to get the raytebValue

    const toDateInput = document.getElementById("toDate"); // Assuming you have an element with id "toDate"
    const raytebValue = toDateInput?.getAttribute("rayteb-value");
    const newToDate = new Date(raytebValue!);
    setToDate(newToDate);
    dispatch(setDateFilter({ from: dateFilter.from, to: newToDate }));
  };

  return (
    <>
      <div className="col-span-1">
        <DatePicker
          innerText="از تاریخ"
          isRequired={true}
          className="h-7 w-full"
          id="fromDate"
          name="fromDate"
          raytebValue={fromDate}
          value={fromDate?.toShamsi()}
          onChange={handleFromDateChange}
        />
      </div>
      <div className="col-span-1">
        <DatePicker
          innerText="تا تاریخ"
          isRequired={true}
          className="h-7 w-full"
          id="toDate"
          name="toDate"
          raytebValue={toDate}
          value={toDate?.toShamsi()}
          onChange={handleToDateChange}
        />
      </div>
    </>
  );
};

export default React.memo(DateFilter);
